import { defineStore } from 'pinia';
import { axiosLevelTech } from '@/services/axiosConfig';
import { Player } from '@/types/componentTypes';
import { getPlayerDetails, getPlayersDetails } from '@/services/boxes/playerServices';

interface PlayerState {
  players: Player[];
}

// Definition of the user store using Pinia
export const usePlayerStore = defineStore('player', {
  state: (): PlayerState => (
    {
      players: [],
    }
  ),
  getters: {
    Players: (state): Player[] => state.players,
    PlayerIds: (state): number[] => state.players.map(p => Number(p.playerid)),
  },
  actions: {
    getPlayer(playerId: string): Player | undefined {
      // if player is not in store, get from server
      let player = this.players.find(p => Number(p.playerid) === Number(playerId));
      if (!player) {
        getPlayerDetails({ playerId: playerId }).then((response) => {
          if (response.data)
            this.addPlayerToStore(response.data);
            player = response.data.data;
        });
      }

      return player;
    },
    async getPlayers(playerIds: string[]): Promise<Player[]> {
      const playerIdsInt = playerIds.map(p => Number(p));
      // get list of players not in store
      const missingPlayers = playerIdsInt.filter(p => !this.PlayerIds.includes(p));

      //get missing players from server
      if (missingPlayers.length > 0) {
        const response = await getPlayersDetails({ playerIds: missingPlayers });
        if (response.data) {
          this.addPlayersToStore(response.data);
        }
      }

      //return list of players
      const players = this.players.filter(p => playerIdsInt.includes(Number(p.playerid)));

      return players;
    },
    addPlayerToStore(player: Player): void {
      if (player.playerid && Number(player.playerid) < 0)
        return;

      if (this.players.length > 0) {
        const playerIndex = this.players.findIndex(p => p.playerid === player.playerid);
        if (playerIndex >= 0) {
          this.players[playerIndex] = player;
        } else {
          this.players.push(player);
        }
      }
      else {
        this.players.push(player);
      }
    }, 
    addPlayersToStore(players: Player[]): void {
        for (const player of players) {

          if (player.playerid && Number(player.playerid) < 0)
            continue;

          const playerIndex = this.players.findIndex(p => p.playerid === player.playerid);
          if (playerIndex >= 0) {
            this.players[playerIndex] = player;
          }
          else {
            this.players.push(player);
          }
        }
    },
    getPlayerName(playerId: number): string {
      if (!playerId) return 'Unknown Player';

      if (playerId < 0 ) return 'Unknown Player';

      const player = this.players.find(p => Number(p.playerid) === Number(playerId));;
      return player ? player.player ?? 'Name Not Known' : 'Unknown Player';
    }
  }
});